import { render } from "./PopupIT.vue?vue&type=template&id=f0e8b896&scoped=true"
import script from "./PopupIT.vue?vue&type=script&lang=js"
export * from "./PopupIT.vue?vue&type=script&lang=js"

import "./PopupIT.vue?vue&type=style&index=0&id=f0e8b896&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0e8b896"]])

export default __exports__